import { LeftOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import ApplicantList from "./ApplicantList";

const ApplicantTrackingBody = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col ">
      <div className="flex items-end">
        <div className="flex-1 flex justify-start">
          <LeftOutlined
            onClick={() => navigate(`/recruitment`)}
            className="cursor-pointer inline-flex items-center justify-center p-2 rounded-full transition-all duration-200 hover:border hover:border-gray-300 hover:shadow-md"
            style={{ fontSize: "35px" }}
          />
        </div>

        <h2 className="text-3xl font-bold text-center p-0 m-0">LIST OF APPLICANT</h2>

        <div className="flex-1" />
      </div>
      <div className="my-9 mx-6">
        <ApplicantList />
      </div>
    </div>
  );
};

export default ApplicantTrackingBody;
